import combineReducers from 'combine-reducers-global-state';
import { addToPagination } from 'redux/helpers/pagination';
import types from './types';

const sectionsByFolderVariantForMember = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getSectionsByFolderVariantForMember:
      if (!payload.page || payload.page === 1) {
        return { ...state, [payload.folderVariantId]: {} };
      }

      return state;
    case types.getSectionsByFolderVariantForMemberSuccess:
      return addToPagination(state, payload.folderVariantId, payload, 'sectionIds');
    default:
      return state;
  }
};

const sectionsByFolderVariantForAdmin = (state = {}, { type, payload }) => {
  switch (type) {
    case types.getSectionsByFolderVariantForAdminSuccess:
      return { ...state, [payload.folderVariantId]: payload.data };
    case types.deleteSectionForAdminSuccess:
      // eslint-disable-next-line eqeqeq
      return { ...state, [payload.folderVariantId]: state[payload.folderVariantId].filter((value) => value != payload.sectionId) };
    default:
      return state;
  }
};

const sectionReducers = combineReducers({
  sectionsByFolderVariantForMember,
  sectionsByFolderVariantForAdmin,
});

export default { documentSection: sectionReducers };
